import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";
const headers = { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY }

const DashboardStatsService = {
  dashboardConent: (params = {}, token) => {
    return axiosInstance.get(ApiUrlConstant.dashboardStats(), {
      params, headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getTopInspectors: (params = {}, token) => {
    return axiosInstance.get(ApiUrlConstant.getTopinspectors(), {
      params, headers: {
        ...headers,
        Authorization: `Bearer ${token}`
      },
    })
  }
};

export default DashboardStatsService;
